// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"SliderFilter_clearfix__CzjhM","thumbMin":"SliderFilter_thumbMin__b3BpF","thumbMax":"SliderFilter_thumbMax__pd829"};